/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfSurfaceSO2 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Surface SO2",
            service: CorsAnywhere + "https://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_so2_surface",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>Two thirds of global SO<sub>2</sub> emissions come from powerplants and industries burning coal and oil. India is
                the top emitter of anthropogenic SO<sub>2</sub> amounting to 15% of global emissions. Norilsk smelter complex in Russia is the largest SO<sub>2</sub> emitter hotspot. Second biggest emitter hotspot is Kriel in Mpumalanga province in South Africa and the third biggest is Zagroz in Iran. Color coding of this data layer: In red and yellow are color the most contaminated areas. As an example, you can zoom in to Chelyabinsk and Magnitogisrsk and
                observe big SO<sub>2</sub> contamination spots colored in dark red to visualize pollution of the area in terms of SO<sub>2</sub>. These areas in Russia are known for its iron and are currently in operation. </p>
            <p><a href="https://www.greenpeace.org/international/press-release/23819/global-so2-air-pollution-hotspots-ranked-by-greenpeace-analysis/" target="_blank" rel="noopener noreferrer">Read more here.</a></p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_so2_surface&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                ppbv (parts per billion by volume)
            </p>
        </div>);
    }
}
